import React from 'react';

import {
  Hero,
  Navbar,
  NewsletterPopup,
  ProgramSlider,
  Contact,
} from 'modules/orqaDeveloperProgram';

import pilotBoard from '../../../main/assets/images/orqaDeveloperProgram/autoboard_general.webp';
import pilotBoardFront from '../../../main/assets/images/orqaDeveloperProgram/autoboard_front.webp';
import pilotBoardTop from '../../../main/assets/images/orqaDeveloperProgram/autoboard_top.webp';
import pilotBoardBack from '../../../main/assets/images/orqaDeveloperProgram/autoboard_back.webp';
import esc from '../../../main/assets/images/orqaDeveloperProgram/esc_general.webp';
import escFront from '../../../main/assets/images/orqaDeveloperProgram/esc_front.webp';
import escTop from '../../../main/assets/images/orqaDeveloperProgram/esc_top.webp';
import escBack from '../../../main/assets/images/orqaDeveloperProgram/esc_back.webp';
import quad from '../../../main/assets/images/orqaDeveloperProgram/quad_general.webp';
import quadFront from '../../../main/assets/images/orqaDeveloperProgram/quad_front.webp';
import quadTop from '../../../main/assets/images/orqaDeveloperProgram/quad_top.webp';
import quadBack from '../../../main/assets/images/orqaDeveloperProgram/quad_back.webp';
import camera from '../../../main/assets/images/orqaDeveloperProgram/camera_general.webp';
import cameraFront from '../../../main/assets/images/orqaDeveloperProgram/camera_front.webp';
import cameraTop from '../../../main/assets/images/orqaDeveloperProgram/camera_top.webp';
import cameraBack from '../../../main/assets/images/orqaDeveloperProgram/camera_back.webp';

const programSlides = [
  {
    id: 1,
    title: 'ORQA Auto Pilot Board',
    description:
      'The DTK auto pilot board (APB) combines a flight controller (STM32H743) and an onboard computer (i.MX8M Plus) optimized for mobile robotics. The result is ideal for developing FPV and hybrid smart drones/robots. The APB supports common flight control firmware like PX4, Ardupilot, Betaflight, and iNav, while the onboard computer can handle complex applications like real-time AI, sensor integration, and video processing.',
    mainImage: pilotBoard,
    thumbnails: [pilotBoard, pilotBoardFront, pilotBoardTop, pilotBoardBack],
  },
  {
    id: 2,
    title: 'ORQA H7 QuadCore',
    description:
      "The Orqa H7 QuadCore is a flight controller designed specifically for Quadcopter drones. It features a powerful STM32H743 MCU and supports common firmware like Betaflight, iNav, ArduPilot, and PX4. The board is fully NDAA-compliant and offers seamless plug-and-fly connectivity with Orqa's various radio and video links.",
    mainImage: quadBack,
    thumbnails: [quadBack, quadFront, quadTop, quad],
  },
  {
    id: 3,
    title: 'ORQA ESC 3030',
    description:
      'The Orqa ESC3030 is a high-performance brushless electronic speed controller for Quadcopter FPV drones. It’s rated at 70A continuous and features a 30x30mm mounting pattern. The ESC3030 comes pre-flashed with AM32 firmware and is 100% plug-and-play ready with the Orqa FC lineup.',
    mainImage: escBack,
    thumbnails: [escBack, esc, escFront, escTop],
  },
  {
    id: 4,
    title: 'ORQA Justice (D) FPV Camera',
    description:
      'The Justice (D) Camera has everything you need to elevate your FPV experience. Equipped with a Sony 1/2.8" CMOS sensor and 1280x720px resolution, it captures imagery at up to 60 FPS, offers MIPI digital CSI video output, and - like all Orqa gear - is proudly made in the EU.',
    mainImage: camera,
    thumbnails: [camera, cameraTop, cameraFront, cameraBack],
  },
];

export const OrqaDeveloperProgram = () => {
  return (
    <section className="orqa-developer-program-section">
      <NewsletterPopup />
      <Navbar />
      <Hero />
      <ProgramSlider slides={programSlides} />
      <div className="program-contact-form-section">
        <Contact />
      </div>
    </section>
  );
};
